<template>
  <div class="row">
    <div class="col-md-12">
      <span style="font-weight: bold">{{title}} ({{cat}})</span>
      <br />
      <span style="font-size: 12px" v-html="htmldescription" />
      <div v-for="file in files" :key="file.name">
        <a target="blank" :href="fileurl + file.name">
          <i class="text-black ni file-text"></i>
          {{file.name.substring(
          file.name.indexOf("_") + 1
          )}}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ShowLink, HtmlNewLine, fileUrl } from "../../../services/helper";
export default {
  name: "resource-item",
  props: {
    cat: String,
    title: String,
    description: String,
    files: Array,
    date: String,
  },
  computed: {
    htmldescription() {
      return ShowLink(HtmlNewLine(this.description));
    },
    fileurl() {
      return fileUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>